function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "stopper",
  transform: "translate(-1200.496 -840)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_5639",
  "data-name": "Rectangle 5639",
  width: 56,
  height: 56,
  transform: "translate(1200.496 840)",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  id: "timer-clock",
  transform: "translate(1203.871 844)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_3258",
  "data-name": "Ellipse 3258",
  cx: 17.25,
  cy: 17.25,
  r: 17.25,
  transform: "translate(11.125 12)",
  fill: "#f5f5f7"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_3259",
  "data-name": "Ellipse 3259",
  cx: 9.75,
  cy: 9.75,
  r: 9.75,
  transform: "translate(18.625 19.5)",
  fill: "#ff0660"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_3261",
  "data-name": "Ellipse 3261",
  cx: 3,
  cy: 3,
  r: 3,
  transform: "translate(25.375 26.25)",
  fill: "#f5f5f7"
}), /*#__PURE__*/React.createElement("path", {
  id: "Subtraction_62",
  "data-name": "Subtraction 62",
  d: "M22746.594,6662.812h-.148a18.085,18.085,0,0,1-13.035-5.555.992.992,0,0,1-.281-.71,1.008,1.008,0,0,1,1-.987.978.978,0,0,1,.715.309,16.1,16.1,0,0,0,11.611,4.943h.074a16.639,16.639,0,0,0,12.105-5.332,16.758,16.758,0,0,0,0-21.836,16.662,16.662,0,0,0-12.105-5.332h-.074a16.134,16.134,0,0,0-11.611,4.949,1,1,0,0,1-.715.3,1.023,1.023,0,0,1-.7-.28.972.972,0,0,1-.3-.7.99.99,0,0,1,.279-.714,18.032,18.032,0,0,1,11.646-5.492l.48-.034-.018-.486-.006-.035a.229.229,0,0,1,0-.028V6623.7l-.332-.12a3.841,3.841,0,0,1-2.178-1.834,4.2,4.2,0,0,1,.828-4.92,4.057,4.057,0,0,1,5.361,0,4.192,4.192,0,0,1,.834,4.92,3.841,3.841,0,0,1-2.178,1.834l-.336.12v2.092a.05.05,0,0,1,0,.023.246.246,0,0,0,0,.04l-.018.486.48.034a18.158,18.158,0,0,1,10.365,4.3l.355.3,2.119-2.12a1,1,0,0,1,1.412,1.417l-2.119,2.12.3.354a17.634,17.634,0,0,1,4.246,9.572,18.816,18.816,0,0,1-7.973,17.424A17.793,17.793,0,0,1,22746.594,6662.812Zm-.084-45a1.992,1.992,0,1,0,1.416.583A2,2,0,0,0,22746.51,6617.813Z",
  transform: "translate(-22718.51 -6615.313)",
  fill: "#000072"
}), /*#__PURE__*/React.createElement("path", {
  id: "Subtraction_63",
  "data-name": "Subtraction 63",
  d: "M22766.381,6637.313a.992.992,0,0,1-.707-.292l-5.5-5.5-.314.149a4,4,0,1,1,1.881-1.886l-.154.32,5.508,5.5a1,1,0,0,1-.709,1.708Zm-8.25-11.251a2,2,0,0,0-2,2,2,2,0,0,0,2,2,2,2,0,0,0,0-4Zm-9.748,10.5h-11.252a1,1,0,0,1,0-2h11.252a1,1,0,0,1,0,2Zm-4.5-7.5h-9.748a1,1,0,0,1,0-2h9.748a1,1,0,0,1,0,2Zm4.5-7.5h-11.252a1,1,0,0,1,0-2h11.252a1,1,0,0,1,0,2Zm9.748-3.749a1,1,0,0,1-.709-.3.981.981,0,0,1-.291-.7,1,1,0,0,1,1.709-.708,1,1,0,0,1-.709,1.708Z",
  transform: "translate(-22730.129 -6598.813)",
  fill: "#000072"
})));

function SvgStopper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopper);
export default __webpack_public_path__ + "static/media/stopper.d49f3ce3.svg";
export { ForwardRef as ReactComponent };